import { TreeNode } from "@/types/ModelTreeNode";

const reduce = <T>(node: TreeNode, callbackFn: (currentNode: TreeNode, currentValue: T) => T, initialValue: T) => {
  let currentValue = callbackFn(node, initialValue);

  if (node.children) {
    for (const child of node.children) {
      currentValue = reduce(child, callbackFn, currentValue);
    }
  }

  return currentValue;
};

const getNodeWithKey = (key: string, nodes: TreeNode[]): TreeNode | undefined => {
  if (nodes) {
    for (const node of nodes) {
      //console.log(`n? ${node.data.label} ${node.key}`);
      if (node.key === key) {
        return node;
      }

      if (node.children) {
        //console.log(`Searching children of ${node.data.label} ${node.key}...`);
        const matchedNode = getNodeWithKey(key, node.children);
        if (matchedNode) {
          //console.log(`Found ${matchedNode.data.label} ${matchedNode.key}`);
          return matchedNode;
        }
      }
    }
  }
  return undefined;
};

const getParentFromKey = (parent: TreeNode | undefined, key: string, nodes: TreeNode[]): TreeNode | undefined => {
  if (nodes) {
    for (const node of nodes) {
      //console.log(`n? ${node.data.label} ${node.key}`);
      if (node.key === key) {
        return parent;
      }

      if (node.children) {
        //console.log(`Searching children of ${node.data.label} ${node.key}...`);
        const parentNode = getParentFromKey(node, key, node.children);
        if (parentNode) {
          //console.log(`Found ${matchedNode.data.label} ${matchedNode.key}`);
          return parentNode;
        }
      }
    }
  }
  return undefined;
};

// Always return a top level node instead of the child
const getCategoryFromKey = (key: string, childNodes: TreeNode[]): TreeNode | undefined => {
  //console.log(`Searching for Category ${key} ...`);

  if (childNodes) {
    for (const node of childNodes) {
      //console.log(`c? ${node.data.label} ${node.key}`);
      if (node.key === key) {
        return node;
      }

      if (node.children) {
        //console.log(`Searching children of ${node.data.label} ${node.key}...`);
        const matchedNode = getNodeWithKey(key, node.children);
        if (matchedNode) {
          //console.log(`Found ${matchedNode.data.label} ${matchedNode.key}...`);
          return node;
        }
      }
    }
  }
  return undefined;
};

const visitNodes = (nodes: TreeNode[], callbackFn: (childNodes: TreeNode[], node: TreeNode) => void) => {
  if (nodes) {
    for (const node of nodes) {
      //console.log('node: ', node.data.label);

      callbackFn(nodes, node);

      if (node.children) {
        visitNodes(node.children, callbackFn);
      }
    }
  }
};

export { getCategoryFromKey, getNodeWithKey, getParentFromKey, reduce, visitNodes };
